export function toYesNo(value: Nullish<boolean>): string | null {
    if (value == null) return null;

    return value
        ? "Yes"
        : "No";
}